/**
 * Carries the post-sign-in target from `main.tsx`'s redirect handling to the
 * router, which does not exist yet at the moment MSAL resolves the redirect.
 *
 * Module-level rather than storage: it is consumed exactly once, in the same
 * page load that produced it, and leaving it in sessionStorage would make a
 * later manual navigation snap back to a stale target.
 */

let target: string | null = null;

export function setRestoreTarget(value: string | null): void {
  target = value;
}

/** Returns the target once, then forgets it. */
export function consumeRestoreTarget(): string | null {
  const value = target;
  target = null;
  return value;
}
